<div class="alert-container position-fixed" >
  @for (msg of messages; track msg) {
    <div class="alert alert-{{ msg.type }}" role="alert">
      @if (msg.type == 'success') {
        <span class="dripicons-checkmark mr-2"></span>
      }
      @if (msg.type == 'danger') {
        <span class="dripicons-wrong mr-2"></span>
      }
      @if (msg.type == 'warning') {
        <span class="dripicons-warning mr-2"></span>
      }
      @if (msg.type == 'info') {
        <span class="dripicons-information mr-2"></span>
      }
      {{ msg.text }}
    </div>
  }
</div>
